// @flow
import React, { useEffect, useState } from "react";
import classnames from "classnames";

import Portal from "Layout/Portal";

import { ReactComponent as BadgeHorizontal } from "./images/StW_L_Ftest_siegel_q_breit_gr_rgb_2.svg";
import { ReactComponent as BadgeVertical } from "./images/StW_L_Ftest_siegel_hoch_gr_rgb.svg";

import Styles from "./Badge.module.scss";

type Props = {
  float?: boolean,
  homepage?: boolean,
  lp?: boolean,
};

const Badge = ({ float, homepage, lp }: Props) => {
  const mainLayout = document.getElementById("mainLayout");
  const [isVertical, setIsVertical] = useState(lp);

  const handleScroll = () => {
    if (!lp && mainLayout) {
      const position = mainLayout.scrollTop;
      if (position > 200) setIsVertical(true);
      else setIsVertical(false);
    }
  };

  useEffect(() => {
    mainLayout?.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      mainLayout?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {float && (
        <Portal>
          <a
            href="https://www.remind.me/strom/ratgeber/die-stiftung-warentest-empfiehlt-remind-me"
            target="_blank"
            rel="noreferrer"
            className={classnames(Styles.badgeWrapper, Styles.floating, {
              [Styles.homepage]: homepage,
              [Styles.lp]: isVertical,
            })}
          >
            {isVertical ? <BadgeVertical /> : <BadgeHorizontal />}
          </a>
        </Portal>
      )}
      <a
        href="https://www.remind.me/strom/ratgeber/die-stiftung-warentest-empfiehlt-remind-me"
        target="_blank"
        rel="noreferrer"
      >
        <div className={classnames(Styles.badgeWrapper, { [Styles.homepage]: homepage, [Styles.hide]: float })}>
          <BadgeHorizontal />
        </div>
      </a>
    </>
  );
};

export default Badge;
